var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.drEditCampaign)?_c('section',[_c('dr-edit-campaign')],1):_vm._e(),(_vm.arEditCampaign)?_c('section',[_c('ar-edit-campaign')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }